import { createColumnHelper } from "@tanstack/react-table";
import { times } from "lodash-es";

import { Cell, Header, TableComp } from "src/base-components/Table";
import { Skeleton } from "src/design-system/Skeleton";

type DummyRow = {
  column1: string;
  column2: string;
  column3: string;
  column4: string;
  column5: string;
};

const helper = createColumnHelper<DummyRow>();

const columns = times(5, (index) =>
  helper.accessor(() => "", {
    id: `column${index + 1}`,
    header: (info) => (
      <Header info={info}>
        <Skeleton height="h-5" width="w-20" />
      </Header>
    ),
    cell: (info) => (
      <Cell info={info}>
        <Skeleton height="h-5" />
      </Cell>
    ),
  }),
);

const groupColumns = [
  helper.accessor((_row, index) => index, {
    id: "index",
    size: 28,
    header: (info) =>
      info.header.depth === 2 ? null : <Header info={info}>#</Header>,
    cell: (info) => (
      <Cell info={info}>
        <Skeleton height="h-5" />
      </Cell>
    ),
  }),
  helper.group({
    id: "entity",
    columns,
    header: (info) => (
      <Header info={info}>
        <Skeleton height="h-5" width="w-20" />
      </Header>
    ),
  }),
];

const data = times(5, (index) => ({
  column1: `column${index + 1}`,
  column2: `column${index + 1}`,
  column3: `column${index + 1}`,
  column4: `column${index + 1}`,
  column5: `column${index + 1}`,
  column6: `column${index + 1}`,
  column7: `column${index + 1}`,
}));

export const EntitiesPreviewSkeleton = () => {
  return (
    <div className="flex h-full flex-col gap-y-3">
      <Skeleton height="h-6" width="w-50" />

      <TableComp
        columns={groupColumns}
        data={data}
        headerPropsGetter={() => ({ classNameOverrides: "bg-gray-50" })}
        variant="compact"
      />
    </div>
  );
};
